function ProductCell({picture, name, sku}) {
    return (
        <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
            <div>
                <img
                    alt={name || sku || ''}
                    src={picture}
                    style={{
                        objectFit: 'contain',
                        height: '36px',
                        width: '36px'
                    }}
                />
            </div>
            <div>
                <div style={{fontWeight: "600", fontSize: "14px", color: "#111827"}}>{name}</div>
                <div style={{fontSize: "12px", color: "#9ca3af", marginTop: "2px"}}>{sku}</div>
            </div>
        </div>
    )
}

export default ProductCell;
